import { render } from "./TeamDocuments.vue?vue&type=template&id=2b54775c"
import script from "./TeamDocuments.vue?vue&type=script&lang=js"
export * from "./TeamDocuments.vue?vue&type=script&lang=js"

import "./TeamDocuments.vue?vue&type=style&index=0&id=2b54775c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__